/* eslint-disable react/self-closing-comp */
/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ALL, SELECTED } from '../../../Utils/Constants/GlobalConstants';
import './css/OperatorsFilter.css';
import {
  changeOperatorsFilter,
  changeIsAllOperatorsTab,
} from '../../../DataStore/actions/FiltersAction';
import { operators } from '../../../Utils/Constants/Operators';
import { ReactComponent as ClearCross } from '../../../images/clear-cross-r.svg';
import { ReactComponent as DefaultCheck } from '../../../images/default-check-r.svg';
import { ReactComponent as ActiveCheck } from '../../../images/active-check-r.svg';

const mapStateToProps = (state) => ({ ...state });

class OperatorsFilter extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  hadleCheckBox = (item) => {
    const {
      operatorsFilter,
      changeOperatorsFilter: changeOperatorsFilterAction,
      handleOperatorFilter,
    } = this.props;

    let newSelectedOperators;
    if (operatorsFilter.filter((e) => e === item).length === 1) {
      newSelectedOperators = operatorsFilter.filter((e) => e !== item);
    } else {
      newSelectedOperators = operatorsFilter.concat([item]);
    }

    changeOperatorsFilterAction(newSelectedOperators);
    handleOperatorFilter(newSelectedOperators);
  };

  renderOperators = (oper) =>
    oper.map((operator) => {
      const { operatorsFilter } = this.props;
      const isChecked =
        operatorsFilter.filter((e) => e.id === operator.id).length === 1;

      return (
        <button
          key={`operator-${operator.id}`}
          type="button"
          className="filter_description"
          onClick={() => this.hadleCheckBox(operator)}
        >
          {isChecked ? (
            <ActiveCheck className="tr_filter_check" />
          ) : (
            <DefaultCheck className="tr_filter_check" />
          )}
          <div>{operator.name}</div>
        </button>
      );
    });

  renderSelectedOperators = (selectedOperators) =>
    selectedOperators.map((selectedOperator) => (
      <button
        key={`selectedOperator-${selectedOperator.id}`}
        type="button"
        className="filter_description"
        onClick={() => this.hadleCheckBox(selectedOperator)}
      >
        <ActiveCheck className="tr_filter_check" />
        <div>{selectedOperator.name}</div>
      </button>
    ));

  handleTabClick = (isAllTabNew) => {
    const { changeIsAllOperatorsTab: changeIsAllOperatorsTabAction } =
      this.props;

    changeIsAllOperatorsTabAction(isAllTabNew);
  };

  handleClear = () => {
    const {
      changeOperatorsFilter: changeOperatorsFilterAction,
      handleOperatorFilter,
    } = this.props;

    changeOperatorsFilterAction([]);
    handleOperatorFilter([]);
  };

  render() {
    const { operatorsFilter, isAllOperatorsTab } = this.props;

    return (
      <div>
        <div className="op_button_w">
          <button
            type="button"
            className={
              isAllOperatorsTab ? 'op_button op_tab_selected' : 'op_button'
            }
            onClick={() => this.handleTabClick(true)}
          >
            {ALL}
          </button>
          {operatorsFilter.length > 0 && (
            <div className="op_clear_button_w">
              <button
                type="button"
                className={
                  isAllOperatorsTab ? 'op_button' : 'op_button op_tab_selected'
                }
                onClick={() => this.handleTabClick(false)}
              >
                <div>{SELECTED}</div>
                <div className="op_counter">{operatorsFilter.length}</div>
              </button>
              <button type="button" onClick={this.handleClear}>
                <ClearCross />
              </button>
            </div>
          )}
        </div>

        {isAllOperatorsTab ? (
          <div className="op_hotels_w custom_scroll_container">
            {this.renderOperators(operators)}
          </div>
        ) : (
          <div className="op_hotels_w custom_scroll_container">
            {this.renderSelectedOperators(operatorsFilter)}
          </div>
        )}
      </div>
    );
  }
}

OperatorsFilter.propTypes = {
  operatorsFilter: PropTypes.instanceOf(Array).isRequired,
  changeOperatorsFilter: PropTypes.func.isRequired,
  handleOperatorFilter: PropTypes.func.isRequired,
  isAllOperatorsTab: PropTypes.bool.isRequired,
  changeIsAllOperatorsTab: PropTypes.func.isRequired,
};

OperatorsFilter.defaultProps = {};

export default connect(mapStateToProps, {
  changeOperatorsFilter,
  changeIsAllOperatorsTab,
})(OperatorsFilter);
